import _ from 'underscore';

import { stringKeyToTuple, tupleToStringKey } from 'js/lib/stringKeyTuple';

/**
 * Key to a report in the Report Store. Immutable once instantiated.
 *
 * @param {string} scopeName - course or global
 * @param {string} scopeId - if scope is course, then the id of the course
 * @param {string} reportName - name of the report (schema).
 * @param {string} [itemId] - item within the scope
 */
const ReportKey = function (scopeName: $TSFixMe, scopeId: $TSFixMe, reportName: $TSFixMe, itemId?: $TSFixMe) {
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.scopeName = scopeName;
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.scopeId = scopeId;
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.reportName = reportName;
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.itemId = itemId;

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  this.id = this.makeString();

  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  Object.freeze(this);
};

ReportKey.prototype.getReportName = function () {
  return this.reportName;
};

/**
 * @return unique ID for use in the query string for requests
 */
ReportKey.prototype.toString = function () {
  return this.id;
};

ReportKey.prototype.makeString = function () {
  let scopeName;
  switch (this.scopeName) {
    case 'Global':
      scopeName = 'Global';
      break;
    case 'Partner':
      scopeName = 'Partner';
      break;
    case 'Specialization':
      scopeName = 'Specialization';
      break;
    default:
      scopeName = 'Course';
      break;
  }
  const reportName = this.getReportName();

  const parts = [scopeName, this.scopeId];

  if (this.itemId) {
    parts.push('Item');
    parts.push(this.itemId);
  }

  parts.push(reportName);

  return tupleToStringKey(parts);
};

ReportKey.fromNaptimeResponse = function (response: $TSFixMe) {
  let subscopeId = null; // to pass to ReportKey constructor

  if (response.subscope) {
    const subscope = response.subscope.split('~'); // Returns array of [ScopeName, ScopeId]
    const subscopeName = subscope[0];

    if (subscopeName !== 'Item') {
      throw Error('ReportKey assumes subscope is Item');
    }
    subscopeId = subscope[1]; // subscopeId
  }

  const [scopeName, scopeId] = stringKeyToTuple(response.scope);

  // @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
  return new ReportKey(
    scopeName,
    scopeId,
    response.name,
    subscopeId // may be
  );
};

export default ReportKey;
